import ChartWidgetFilter from './ChartWidgetFilter';

export default ChartWidgetFilter;
